import React from "react";

import "./spread-overview-thumb.css";
import classNames from "classnames";

/** Contains a preview of a thumb */
export const SpreadOverviewThumb = ({
	spread,
	isLoading,
	isError,
	isSelected,
	onClick,
	ref,
}: {
	spread: eXpress.core.Spread;
	isLoading?: boolean;
	isError?: boolean;
	isSelected?: boolean;
	onClick?: () => void;
	ref?: React.Ref<HTMLDivElement>;
}) => {
	const className = classNames("spread-overview-thumb", {
		"spread-overview-thumb--loading": isLoading,
		"spread-overview-thumb--error": isError,
		"spread-overview-thumb--selected": isSelected,
	});

	// This div will be filled with a canvas and svg layer
	return (
		// eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions
		<div
			ref={ref}
			className={className}
			style={
				{
					"--spread-aspect-ratio": `${spread.width}/${spread.height}`,
					aspectRatio: "var(--spread-aspect-ratio)",
				} as React.CSSProperties
			}
			onClick={onClick}
			role="img"
		></div>
	);
};

SpreadOverviewThumb.displayName = "SpreadOverviewThumb";
